export enum PostEventType {
  discord = 'discord',
  meets = 'meets',
  youtube = 'youtube',
  zoom = 'zoom',
  other = 'other',
}
